import { CustomMutationParams } from "@/hooks/useMutationWithErrorDialog"

// Every payload error is handled by useTelematikInfrastructureDocumentSigning itself: the activation-is-needed
// outcome starts the comfort signature activation subscription, every other failure needs the errorType to
// pick its translation
const TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS: CustomMutationParams = {
  shouldShowErrorDialog: false,
  considerErrorAsBlocking: () => false,
}

export { TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS }
